// extracted by mini-css-extract-plugin
module.exports = {"employee_projects":"EmployeeProjects_employee_projects__QcoNS","modal_heading":"EmployeeProjects_modal_heading__3U0UO","data":"EmployeeProjects_data__2MYNW"};